import api from "./api";

export const fetchProducts = async () => {
  const res = await api.get('/get_products');
  return res.data;
};

export const fetchUsers = async () => {
  const res = await api.get('/get_users');
  return res.data;
}

export const fetchTransactions = async (fetchAll, userId) => {
  const res = await api.get('/get_transactions', {
    params: fetchAll ? {} : { user_id: userId }
  });
  return res.data;
};

export const fetchQuotes = async () => {
  const res = await api.get('/get_quotes');
  return res.data;
};

export const editProduct = async (product) => {
		try {
			return await api.post('/edit_product', product);
		} catch (err) {
			console.log('Något oväntat gick fel');
		}
}

export const editUser = async (user) => {
  	try {
			await api.post('/edit_user', user);
		} catch (err) {
			console.log('Något oväntat gick fel');
		}
}

/**
 * Deletes the referenced product from the database.
 * @param {{ id: number, name: string, price: number, image_path: string }} product
 *   The product object to delete, as returned from the server.
 *   Must contain at least the unique `id` property.
 */
export function deleteProduct(product) {
  console.log("DELETING " + product.name)
  return api.post('/delete_product', { id: product.id });
}

/**
 * Deletes the referenced user from the database.
 * @param {{ id: number, name: string, display_name: string, admin: boolean }} user
 *   The user object to delete, as returned from the server.
 *   Must contain at least the unique `id` property.
 */
export function deleteUser(user) {
  console.log("DELETING " + user.name)
  return api.post('/delete_user', { id: user.id });
}

export const getImageUrl = (path) => {
  const baseUrl = process.env.REACT_APP_API_URL || 'https://bax.buster.lol/api';
  return `${baseUrl}/${path}`;
};

export const truncate = (str, len) => {
  return str.length > len ? str.substring(0, len) + "..." : str;
};
